<template>
	<!--客诉详情,待裁决-->
	<div class="wrap">
		<div class="header">
			<div class="top">
				<i class="close">
					<span class="back" @click="back"></span>
					<span class="home" @click="backHome"></span>
				</i>
				<p class="title">待确认</p>
				<div class="pages">
					<i touch class="up" @click.stop="prev"></i>
					<span class="line"></span>
					<i touch class="down" @click.stop="next"></i>
				</div>
			</div>
		</div>
		<div class="dish-info">
			<div class="dish-name">
				{{ detail.productName }}
			</div>
			<div class="dish-unit">{{ detail.unitName }}</div>
			<i class="line-bg"></i>
			<div class="info-time">客诉日期 {{ detail.createTime }}</div>
			<div class="info-store">
				{{ detail.groupName }}-{{ detail.retailName }}
			</div>
			<div class="info-store">{{ detail.providerName }}</div>
		</div>
		<div class="content">
			<div class="date">
				<span>生产日期</span>
				<span>{{ detail.productionDate }}</span>
			</div>
			<!--问题类型-->
			<div class="problem">
				<h3 class="h3">
					问题类型
				</h3>
				<div class="problem-classify">
					<p class="h4">问题分类</p>
					<p class="p2">
						{{ getProblemNameByType(detail.problemType).name }}-{{
							getProblemDetailByType(detail.problemTypeDetail)
								.name
						}}
					</p>
				</div>
				<div class="problem-classify">
					<p class="h4">问题描述</p>
					<p class="p2">
						{{ detail.description }}
					</p>
				</div>
				<div class="problem-select">
					<p class="h4">确认问题分类</p>
					<div class="select mb40" @click="selectProblemType">
						<p v-if="problemTypeListRightItem">
							{{ problemTypeListLeftItem.name }}-{{
								problemTypeListRightItem.name
							}}
						</p>
						<i class="more"></i>
					</div>
				</div>
				<div class="problem-select">
					<p class="h4">客诉分级</p>
					<div class="select mb30" @click="showLevel = true">
						<p>{{ level }}级</p>
						<i class="more"></i>
					</div>
				</div>
			</div>
			<!--解决方案-->
			<div class="solution problem">
				<h3 class="h3">
					解决方案
				</h3>
				<div class="bottom">
					<div class="left">
						<div class="reduction">
							<i class="bg"></i>
							<span>{{ detail.retailPlanTypeName }}</span>
						</div>
						<div class="solution-row">
							<div class="solution-info">
								<p class="p1">不合格数量：</p>
								<p class="p2">
									<span class="span1">
										{{ detail.retailComplaintQty }}
									</span>
									<span class="span2">{{
										detail.unitName
									}}</span>
								</p>
							</div>
							<div class="solution-info">
								<p class="p1">不合格金额：</p>
								<p class="p2">
									<span class="span1">
										{{ toFixedMoney(detail.amountWithtax) }}
									</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--裁定方案-->
			<div class="problem rule">
				<h3 class="h3">
					裁定方案
				</h3>
				<div class="rule-list">
					<p
						class="rule-li"
						v-for="(item, index) in programmeList"
						@click="programmeListClick(item)"
						:key="index"
						:class="{ active: programmeItem.name == item.name }"
					>
						{{ item.name }}
					</p>
				</div>
				<div
					class="input-div"
					v-show="
						programmeItem.type === 'SELF_PROCUREMENT' ||
							programmeItem.type === 'HANDLE_CUSTOMER_COMPLAINTS'
					"
				>
					<span>涉诉金额</span>
					<input
						@focus="focused = true"
						@blur="focused = false"
						class="input-money"
						type="number"
						v-model="actualPurchaseAmount"
						@input="checkPurchaseNum"
						placeholder="请输入裁定涉诉金额"
					/>
				</div>
				<div class="input-div">
					<span>裁定数量</span>
					<input
						@focus="focused = true"
						@blur="focused = false"
						class="input-money"
						type="number"
						placeholder="请输入裁定数量"
						@input="checkInputNum"
						v-model="actualComplaintQty"
					/>
				</div>
				<div class="input-div">
					<span>备注</span>
					<input
						@focus="focused = true"
						@blur="focused = false"
						class="input-money"
						type="text"
						v-model="actualDescription"
						placeholder="请输入备注，驳回时请务必填写"
						maxlength="200"
					/>
				</div>
				<div class="calc-money">
					<p>裁定不合格金额</p>
					<span>{{ toFixedMoney(actualCusComplaintAmount) }}元</span>
				</div>
			</div>
			<!--图片-->
			<div
				class="problem pic-preview"
				v-show="imgList && imgList.length > 0"
			>
				<h3 class="h3">
					图片
				</h3>
				<div class="pic-list">
					<img
						v-for="(item, index) in imgList"
						:key="index"
						:src="item"
						@click="prevImg(index)"
					/>
				</div>
			</div>
			<img class="bottom" src="../assets/images/img_hint_bottom.png" />
		</div>
		<div class="bottom-btn" v-show="focused == false">
			<p @click="reject">驳回</p>
			<p class="p2" @click="submit">确认供应商承担</p>
		</div>

		<!--选择问题分类-->
		<van-popup v-model="showProblem" round position="bottom">
			<div class="dialog-head">
				<p>选择问题分类</p>
				<img
					@click.stop="showProblem = false"
					src="../assets/images/btn_close.png"
					alt="关闭"
				/>
			</div>
			<div class="dialog-content">
				<div class="dialog-content-left">
					<div
						class="problem-type-li"
						v-for="(item, index) in problemTypeListLeft"
						:class="{
							active: problemTypeListLeftItem2.code == item.code
						}"
						@click.stop="problemTypeListLeftItem2 = item"
						:key="index"
					>
						{{ item.name }}
					</div>
				</div>
				<div class="dialog-content-right">
					<div
						class="problem-type-li"
						v-for="(item, index) in problemTypeListRight"
						:class="{
							active: problemTypeListRightItem2.id == item.id
						}"
						v-show="
							problemTypeListLeftItem2.code == item.parentCode
						"
						@click.stop="problemTypeListRightItem2 = item"
						:key="index"
					>
						<p>{{ item.name }}</p>
						<i class="check"></i>
					</div>
				</div>
			</div>
			<div class="submit" @click.stop="problemTypeSubmit">
				<p>确定</p>
			</div>
		</van-popup>
		<!--客诉分级-->
		<van-popup v-model="showLevel" round position="bottom">
			<div class="dialog-head">
				<p>选择客诉分级</p>
				<img
					@click.stop="showLevel = false"
					src="../assets/images/btn_close.png"
					alt="关闭"
				/>
			</div>
			<div class="show-level-content">
				<div
					class="show-level-li"
					@click.stop="level = 1"
					:class="{ active: level == 1 }"
				>
					<p>1级</p>
					<i class="check"></i>
				</div>
				<div
					class="show-level-li"
					@click.stop="level = 2"
					:class="{ active: level == 2 }"
				>
					<p>2级</p>
					<i class="check"></i>
				</div>
				<div
					class="show-level-li"
					@click.stop="level = 3"
					:class="{ active: level == 3 }"
				>
					<p>3级</p>
					<i class="check"></i>
				</div>
			</div>
			<div class="submit" @click.stop="levelSubmit">
				<p>确定</p>
			</div>
		</van-popup>
	</div>
</template>

<script>
import md5 from "js-md5";
import { config } from "@/common/apis";
import { Toast, Dialog, ImagePreview } from "vant";
import axios from "axios";
import { mapGetters } from "vuex";
import { util } from "@/utils/util";
import { login } from "../common/login/login";
export default {
	name: "customerComplaintsDetail",
	props: {},
	components: {},
	data() {
		return {
			prefix: "https://xibeibk.oss-cn-qingdao.aliyuncs.com/", //图片前缀
			pagesShow: false,
			complaintId: "",
			productCode: "",
			detail: {}, //详情数据
			problemTypeListLeft: [], //问题类型列表左
			problemTypeListRight: [], //问题类型列表右
			showProblem: false, //问题分类弹框
			problemTypeListLeftItem: {}, //左侧已选
			problemTypeListRightItem: {}, //右侧已选
			problemTypeListLeftItem2: {}, //左侧已选
			problemTypeListRightItem2: {}, //右侧已选
			showLevel: false, //客诉分级弹框
			level: 3, //分级
			programmeList: [], //裁定方案列表
			programmeItem: "", //裁定方案

			actualComplaintQty: "", //确认实际客诉物资数量
			actualPurchaseAmount: "", //确认实际自行采购金额
			//actualCusComplaintAmount: "", //确认实际顾客投诉金额

			sessionList: [], //列表数据
			nowIndex: -1, //当前位置
			actualDescription: "", //备注

			unitPrice: "", //物资单价
			retailComplaintQty: "", //"门店不合格数量",
			retailCusComplaintAmount: "", //"门店不合格金额",
			providerPriceWithtax: "", //"供应商不合格金额" //供应商不合格金额
			focused: false
			//backtrackEntity: "不退实物"
			//amount_withtax 含税金额

			// arr: [
			// 	{ amount: 1, count: 2 },
			// 	{ amount: 3, count: 10 },
			// 	{ amount: 4, count: 2 }
			// ]
			// actualComplaintQty 输入
			// "actualCusComplaintAmount": 输出

			// productImgPath
		};
	},
	created() {
		const employee_code = this.$route.query.employee_code;
		if (employee_code) {
			login(employee_code).then(() => {
				this.init();
			});
			return;
		}
		this.init();
	},
	computed: {
		...mapGetters(["authToken", "userNumber"]),
		actualCusComplaintAmount() {
			if (this.detail && this.actualComplaintQty) {
				let actualComplaintQty = this.actualComplaintQty; //总数量
				const priceWithtaxs = this.detail.priceWithtaxs; //计算依据
				let money = 0;
				priceWithtaxs.map(item => {
					if (actualComplaintQty >= 0) {
						const qty = Number(item.qty);
						const priceWithtax = item.priceWithtax;
						//填写的数量大于阶段数量
						if (actualComplaintQty > qty) {
							money += qty * priceWithtax;
							actualComplaintQty = actualComplaintQty - qty;
						} else {
							money += actualComplaintQty * priceWithtax;
							actualComplaintQty = 0;
						}
					}
				});

				return money.toFixed(2);
			}
			return 0;
		},
		imgList() {
			// https://xibeibk.oss-cn-qingdao.aliyuncs.com
			if (this.detail && this.detail.productImgPath) {
				const imgArr = this.detail.productImgPath.split(",");
				// eslint-disable-next-line no-unused-vars
				const imgArr2 = imgArr.map(img => {
					img = config.prefix + img;
					return img;
				});
				console.log(imgArr2);
				return imgArr2;
			}
			return [];
		}
	},
	watch: {},
	methods: {
		back() {
			// this.$router.back();
			this.$router.replace({
				path: "customerComplaintsList",
				query: { index: 1 }
			});
		},
		toFixedMoney(money) {
			if (money) {
				money = Number(money);
				return money.toFixed(2);
			}
			return "";
		},
		init() {
			this.programmeList = config.PROGRAMME_LIST;
			this.complaintId = this.$route.query.complaintId;
			this.productCode = this.$route.query.productCode;
			try {
				const sessionList = sessionStorage.getItem("staffList");
				if (sessionList) {
					this.sessionList = JSON.parse(sessionList);
				}
			} catch (e) {
				Toast(e.message);
			}

			this.getProblemTypeList().then(() => {
				this.getData();
			});
		},
		prevImg(index) {
			ImagePreview({
				images: this.imgList,
				startPosition: index
			});
		},
		//根据productCode获取当前位置，上一页下一页用
		getIndex() {
			if (this.sessionList.length > 0) {
				this.nowIndex = this.sessionList.findIndex(item => {
					return (
						item.complaintId == this.complaintId &&
						item.productCode == this.productCode
					);
				});
			}
		},
		/**
		 * 上一条
		 */
		prev() {
			if (this.nowIndex < 1) {
				Toast("没有上一条了");
				return;
			}
			const complaintId = this.sessionList[this.nowIndex - 1].complaintId;
			const productCode = this.sessionList[this.nowIndex - 1].productCode;
			this.getData(complaintId, productCode);
		},
		/**
		 * 下一条
		 */
		next() {
			if (this.nowIndex == this.sessionList.length - 1) {
				Toast("没有下一条了");
				return;
			}
			const complaintId = this.sessionList[this.nowIndex + 1].complaintId;
			const productCode = this.sessionList[this.nowIndex + 1].productCode;
			this.getData(complaintId, productCode);
		},
		/**
		 * 根据type获取name
		 */
		getProblemNameByType(type) {
			const problem = this.problemTypeListLeft.filter(item => {
				return type === item.code;
			});
			if (problem[0]) {
				return problem[0];
			}
			return "";
		},
		/**
		 * 根据type获取detail
		 */
		getProblemDetailByType(type) {
			const problem = this.problemTypeListRight.filter(item => {
				return type === item.code;
			});
			if (problem[0]) {
				return problem[0];
			}
			return "";
		},
		/**
		 * 回到工作台首页
		 */
		backHome() {
			try {
				// eslint-disable-next-line no-undef
				uni.switchTab({
					url: "/pages/index_copy/index_copy"
				});
			} catch (error) {
				console.log(error);
			}
		},
		/**
		 * 裁定金额验证
		 */
		checkInputNum() {
			this.actualComplaintQty = util.checkMoney(this.actualComplaintQty);

			if (
				Number(this.actualComplaintQty) > this.detail.retailComplaintQty
			) {
				Toast("裁定数量不能大于门店提交的不合格数量");
				this.actualComplaintQty = this.detail.retailComplaintQty;
			}
		},
		checkPurchaseNum() {
			this.actualPurchaseAmount = util.checkMoney(
				this.actualPurchaseAmount
			);
		},
		/**
		 * 选择问题分类
		 * */
		selectProblemType() {
			this.problemTypeListLeftItem2 = JSON.parse(
				JSON.stringify(this.problemTypeListLeftItem)
			);
			this.problemTypeListRightItem2 = JSON.parse(
				JSON.stringify(this.problemTypeListRightItem)
			);

			this.showProblem = true;
		},
		/**
		 * 确认问题分类
		 */
		problemTypeSubmit() {
			if (!this.problemTypeListRightItem) {
				Toast("请选择问题对应的分类");
				return;
			}
			const item2Id = this.problemTypeListRightItem2.id;
			const itemId = this.problemTypeListRightItem.id;
			if (item2Id != itemId) {
				this.problemTypeListRightItem = JSON.parse(
					JSON.stringify(this.problemTypeListRightItem2)
				);

				this.problemTypeListLeftItem = this.getProblemNameByType(
					this.problemTypeListRightItem.parentCode
				);
			}

			this.showProblem = false;
		},
		/**
		 * 确认客诉分级
		 */
		levelSubmit() {
			if (!this.level) {
				Toast("请选择客诉分级");
				return;
			}
			this.showLevel = false;
		},
		/**
		 * 选择裁定方案
		 */
		programmeListClick(item) {
			this.programmeItem = item;
		},
		/**
		 * 确认供应商承担
		 */
		submit() {
			if (!this.programmeItem) {
				Toast("请确认裁定方案");
				return;
			}
			if (!this.actualComplaintQty) {
				Toast("请输入裁定数量");
				return;
			}
			if (
				!this.actualPurchaseAmount &&
				(this.programmeItem.type == "SELF_PROCUREMENT" ||
					this.programmeItem.type == "HANDLE_CUSTOMER_COMPLAINTS")
			) {
				Toast("请输入裁定涉诉金额");
				return;
			}
			this.susEdit("ALREADY_WITH_RULING");
			// this.$router.replace("/customerComplaintsList");
		},
		/**
		 * 驳回
		 */
		reject() {
			if (!this.actualDescription) {
				Toast("驳回请填写备注");
				return;
			}
			Dialog.confirm({
				message: "是否确认驳回？",
				confirmButtonColor: "#5E8DFE"
			}).then(() => {
				this.susEdit("ALREADY_REJECTED");
			});
		},
		/**
		 * 问题类型列表
		 */
		getProblemTypeList() {
			return new Promise((resolve, reject) => {
				axios({
					method: "GET",
					url: config.API_BASE_URI + "app/sus/problemType/list",
					headers: {
						"X-Auth-Token": this.authToken
					},
					data: {},
					timeout: 1000 * 60 // 请求超时时间默认60秒
				})
					.then(res => {
						Toast.clear();
						if (res.data.code == 0) {
							resolve();
							res.data.data.map(item => {
								if (item.level == 1) {
									this.problemTypeListLeft.push(item);
								} else {
									this.problemTypeListRight.push(item);
								}
							});
						} else {
							reject();
							Toast(res.data.msg);
						}
					})
					.catch(err => {
						reject();
						Toast.clear();
						Toast(err.message);
					});
			});
		},
		/**
		 * 获取详情数据
		 */
		getData(complaintId, productCode) {
			if (!complaintId) {
				complaintId = this.complaintId;
			}
			if (!productCode) {
				productCode = this.productCode;
			}
			const md5str =
				this.userNumber + complaintId + productCode + config.SALT;

			const para = {
				userNumber: this.userNumber,
				complaintId: complaintId,
				productCode: productCode,
				sign: md5(md5str)
			};
			Toast.loading();
			axios({
				method: "POST",
				url: config.API_BASE_URI + "app/sus/queryByCodeProduct",
				headers: {
					"X-Auth-Token": this.authToken
				},
				data: para,
				timeout: 1000 * 60 // 请求超时时间默认60秒
			})
				.then(res => {
					Toast.clear();
					if (res.data.code == 0) {
						this.detail = res.data.data;
						if (this.detail.complaintState != "WAIT_WITH_RULING") {
							this.pagesShow = true;
						}
						this.problemTypeListLeftItem = this.getProblemNameByType(
							this.detail.problemType
						);

						this.problemTypeListRightItem = this.getProblemDetailByType(
							this.detail.problemTypeDetail
						);
						this.programmeList.map(item => {
							if (item.type == this.detail.retailPlanType) {
								this.programmeListClick(item);
							}
						});
						this.actualComplaintQty = this.detail.retailComplaintQty;
						if (this.detail.retailPlanType == "SELF_PROCUREMENT") {
							this.actualPurchaseAmount = this.detail.retailPurchaseAmount;
						}
						if (
							this.detail.retailPlanType ==
							"HANDLE_CUSTOMER_COMPLAINTS"
						) {
							this.actualPurchaseAmount = this.detail.retailCusComplaintAmount;
						}
						console.log(this.problemTypeListRight);
						console.log(this.detail.problemTypeDetail);
						//为下一条做准备
						this.complaintId = complaintId;
						this.productCode = productCode;

						this.getIndex();
					} else {
						Toast(res.data.msg);
					}
				})
				.catch(err => {
					Toast.clear();
					Toast(err.message);
				});
		},
		/**
		 * 确认供应商承担
		 * @param complaintState 操作状态  ALREADY_REJECTED 驳回  ALREADY_WITH_RULING 裁定
		 */
		susEdit(complaintState) {
			const md5str =
				this.userNumber +
				this.complaintId +
				this.productCode +
				config.SALT;
			const para = {
				userNumber: this.userNumber,
				complaintId: this.complaintId,
				complaintState: complaintState,
				productCode: this.productCode,
				actualComplaintQty: this.actualComplaintQty,
				actualPriceWithtax: this.actualCusComplaintAmount,
				actualPlanType: this.programmeItem.type,
				actualPlanTypeName: this.programmeItem.name,
				actualDescription: this.actualDescription,
				purchaseProblemTypeDetail: this.problemTypeListRightItem.code,
				purchaseProblemType: this.problemTypeListLeftItem.code,
				level: this.level,
				sign: md5(md5str)
			};
			if (this.programmeItem.type == "SELF_PROCUREMENT") {
				para.actualPurchaseAmount = this.actualPurchaseAmount;
			}
			if (this.programmeItem.type == "HANDLE_CUSTOMER_COMPLAINTS") {
				para.actualCusComplaintAmount = this.actualPurchaseAmount;
			}
			//实际减单金额
			// if (this.programmeItem.type === "MINUS_QTY") {
			// 	para.actualSubtractAmount =
			// 		this.detail.unitPrice * this.actualComplaintQty;
			// }

			axios({
				method: "POST",
				url: config.API_BASE_URI + "app/sus/edit",
				headers: {
					"X-Auth-Token": this.authToken
				},
				data: para,
				timeout: 1000 * 60 // 请求超时时间默认60秒
			})
				.then(res => {
					Toast.clear();
					if (res.data.code == 0) {
						Toast("确认成功");
						// this.$router.back();
						this.$router.replace({
							path: "customerComplaintsList",
							query: { index: 1 }
						});
					} else {
						Toast(res.data.msg);
					}
				})
				.catch(err => {
					Toast.clear();
					Toast(err.message);
				});
		}
	},
	filters: {}
};
</script>

<style scoped>
.wrap {
	position: absolute;
	bottom: 0;
	top: 0;
	width: 7.5rem;
	overflow: hidden;
	background: #f5f6fa;
}

.header {
	height: 3.4rem;
	background: url("../assets/images/img_appeal_details_bg.png") no-repeat;
	background-size: contain;
}

.top {
	display: flex;
	align-items: center;
	position: relative;
	justify-content: center;
	height: 1.2rem;
}

.top .close {
	width: 1.77rem;
	height: 0.6rem;
	background-image: url("../assets/images/icon_back_2icons_blue.png");
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
	position: absolute;
	left: 0.3rem;
	top: 0.3rem;
	display: flex;
	align-items: center;
}

.top .close > span {
	width: 50%;
	height: 100%;
}

.top .title {
	font-size: 0.36rem;
	font-weight: bold;
	color: #ffffff;
	line-height: 0.5rem;
}

.dish-info {
	width: 6.9rem;
	height: 3.37rem;
	background: linear-gradient(90deg, #fdfdff 0%, #e7eefe 100%);
	box-shadow: 0rem 0.04rem 0.1rem 0rem rgba(170, 177, 218, 0.3);
	border-radius: 0.2rem;
	position: absolute;
	top: 1.3rem;
	left: 0.3rem;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0.3rem 0.3rem 0 0.3rem;
}

.dish-name {
	height: 0.32rem;
	font-size: 0.32rem;
	font-weight: bold;
	color: #313f6c;
	line-height: 0.32rem;
	margin-bottom: 0.24rem;
}

.dish-unit {
	display: flex;
	height: 0.4rem;
	background: linear-gradient(90deg, #d9e2ff 0%, #c9d6ff 100%);
	border-radius: 0.2rem 0.02rem 0.2rem 0.02rem;
	border: 0.01rem solid #e2eaff;
	padding: 0 0.2rem;
	color: #4a5a8d;
	font-size: 0.28rem;
	margin-bottom: 0.24rem;
}

.line-bg {
	width: 6.3rem;
	height: 1px;
	background: linear-gradient(90deg, #b8bfd8 0%, #f0f4fe 100%);
	margin-bottom: 0.24rem;
}

.info-time {
	height: 0.28rem;
	font-size: 0.28rem;
	color: #4a5a8d;
	line-height: 0.28rem;
	margin-bottom: 0.24rem;
}

.info-store {
	margin-bottom: 0.24rem;
	color: #4a5a8d;
	font-size: 0.28rem;
}

.content {
	position: absolute;
	width: 7.5rem;
	top: 5rem;
	bottom: 0;
	padding: 0 0.3rem 1.6rem 0.3rem;
	overflow-y: scroll;
}

.date {
	width: 6.9rem;
	height: 0.88rem;
	background: #ffffff;
	box-shadow: 0rem 0.04rem 0.1rem 0rem rgba(192, 205, 221, 0.3);
	border-radius: 0.2rem;
	display: flex;
	align-items: center;
	color: #313f6c;
	font-size: 0.32rem;
	font-weight: bold;
	padding: 0 0.3rem;
}

.date span {
	margin-right: 0.1rem;
}

.problem {
	margin-top: 0.3rem;
	width: 6.9rem;
	/*height: 7.1rem;*/
	background: #ffffff;
	box-shadow: 0rem 0.04rem 0.1rem 0rem rgba(192, 205, 221, 0.3);
	border-radius: 0.2rem;
	padding: 0 0.3rem;
	display: flex;
	flex-direction: column;
}

.h3 {
	height: 0.32rem;
	font-size: 0.32rem;
	font-weight: bold;
	color: #333333;
	line-height: 0.32rem;
	margin: 0.4rem 0;
}

.problem-classify .h4 {
	font-size: 0.28rem;
	color: #888888;
	line-height: 0.28rem;
	margin-bottom: 0.2rem;
}

.problem-classify .p2 {
	font-size: 0.28rem;
	font-weight: bold;
	color: #333333;
	line-height: 0.4rem;
	margin-bottom: 0.36rem;
	word-break: break-all;
}

.problem-select {
	display: flex;
	flex-direction: column;
}

.problem-select .h4 {
	font-size: 0.28rem;
	color: #888888;
	line-height: 0.28rem;
	margin-bottom: 0.2rem;
}

.problem-select .select {
	width: 6.3rem;
	height: 0.8rem;
	background: #f6f6f6;
	border-radius: 0.5rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 0.3rem;
}

.problem-select .select p {
	height: 0.28rem;
	font-size: 0.28rem;
	font-weight: bold;
	color: #333333;
	line-height: 0.28rem;
}

.problem-select .select .more {
	width: 0.24rem;
	height: 0.24rem;
	background: url("../assets/images/day_review_icon_go_blue.png") no-repeat;
	background-size: contain;
}

.mb30 {
	margin-bottom: 0.3rem;
}

.mb40 {
	margin-bottom: 0.4rem;
}

.solution .bottom {
	display: flex;
	padding-bottom: 0.3rem;
}

.solution .bottom > div {
	width: 6.3rem;
	height: 1.36rem;
	background: #eef4fe;
	border-radius: 0.2rem;
	padding: 0.3rem 0.3rem 0 0.3rem;
}

.solution .bottom .right {
	margin-left: 0.1rem;
	background: #fff3e0;
	border-radius: 0rem 0.2rem 0.2rem 0rem;
}

.solution .h5 {
	height: 0.28rem;
	font-size: 0.28rem;
	font-weight: bold;
	color: #313f6c;
	line-height: 0.28rem;
	margin-bottom: 0.3rem;
}

.solution .bottom .right .h5 {
	color: #c46f41;
}

.solution .reduction {
	display: flex;
	align-items: center;
	color: #313f6c;
	font-size: 0.28rem;
	margin-bottom: 0.2rem;
}

.solution .reduction .bg {
	width: 0.28rem;
	height: 0.28rem;
	margin-right: 0.1rem;
	background-image: url("../assets/images/icon_checked_blue.png");
	background-repeat: no-repeat;
	background-size: contain;
}

.solution .right .reduction .bg {
	background-image: url("../assets/images/icon_checked_orange.png");
}

.solution .right .reduction2 .bg {
	background-image: url("../assets/images/icon_unchecked_orange.png");
}

.solution .right .reduction {
	color: #c46f41;
}

.solution-info {
	display: flex;
	align-items: center;
	margin-bottom: 0.2rem;
}

.solution-info .p1 {
	height: 0.28rem;
	font-size: 0.24rem;
	color: #697498;
	line-height: 0.28rem;
	white-space: nowrap;
}

.solution-info .p2 {
	display: flex;
	align-items: center;
	width: 1.4rem;
}
.solution-row {
	display: flex;
	align-items: center;
	flex-direction: row;
}
.right .solution-info .p1 {
	color: #cd865f;
}

.solution-info .p2 .span1 {
	height: 0.28rem;
	font-size: 0.28rem;
	font-weight: bold;
	color: #313f6c;
	line-height: 0.28rem;
}

.right .solution-info .p2 .span1 {
	color: #c46f41;
}

.solution-info .p2 .span2 {
	height: 0.28rem;
	font-size: 0.24rem;
	color: #697498;
	line-height: 0.28rem;
}

.right .solution-info .p2 .span2 {
	color: #cd865f;
}

.rule-list {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 0.1rem;
}

.rule-li {
	padding: 0 0.28rem;
	height: 0.68rem;
	background: #f6f6f6;
	border-radius: 0.34rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	color: #666666;
	font-size: 0.28rem;
	margin: 0 0.2rem 0.2rem 0;
}
.rule-li:nth-of-type(4) {
	margin-right: 0;
}

.rule-li.active {
	background: #eaf3fd;
	color: #5e8dfe;
}

.calc-money {
	width: 6.3rem;
	height: 0.88rem;
	background: #fbfbfb;
	border-radius: 0.2rem;
	display: flex;
	align-items: center;
	padding: 0 0.3rem;
	font-size: 0.28rem;
	color: #888;
	margin-bottom: 0.3rem;
}

.calc-money span {
	color: #f88b50;
	margin-left: 0.2rem;
}

.pic-list {
	display: flex;
	align-items: center;
	margin-bottom: 0.3rem;
}

.pic-list img {
	width: 1.9rem;
	height: 1.9rem;
	border-radius: 0.2rem;
	margin-right: 0.3rem;
}

img.bottom {
	width: 2.64rem;
	height: 0.72rem;
	margin: 0.4rem 2.13rem;
}

.bottom-btn {
	position: fixed;
	bottom: 0.6rem;
	left: 0.3rem;
	display: flex;
	align-items: center;
}

.bottom-btn p {
	width: 3.3rem;
	height: 1rem;
	background: #ffffff;
	border-radius: 0.2rem;
	border: 0.01rem solid #b2c9ff;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #618fff;
	font-size: 0.36rem;
	margin-right: 0.3rem;
}

.bottom-btn p.p2 {
	background: linear-gradient(90deg, #68b3fd 0%, #5c85ff 100%);
	color: #ffffff;
}

.dialog-head {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 1.26rem;
	color: #333333;
	font-weight: bold;
	font-size: 0.32rem;
}

.dialog-head img {
	position: absolute;
	right: 0.3rem;
	top: 0.43rem;
	width: 0.4rem;
	height: 0.4rem;
}

.dialog-content {
	height: 7.82rem;
	display: flex;
	overflow: hidden;
}

.dialog-content-left {
	width: 2.6rem;
	height: 7.82rem;
	background: #f8fafc;
	overflow: scroll;
}

.dialog-content-left .problem-type-li {
	width: 2.6rem;
	height: 1.08rem;
	display: flex;
	align-items: center;
	color: #999999;
	font-size: 0.28rem;
	font-weight: bold;
	padding-left: 0.3rem;
}
.dialog-content-left .problem-type-li.active {
	background: #ffffff;
	color: #333333;
}

.dialog-content-right {
	width: 4.9rem;
	height: 7.82rem;
	background: #fff;
	overflow: scroll;
	padding-bottom: 1rem;
}
.dialog-content-right .problem-type-li {
	width: 4.6rem;
	height: 1.08rem;
	background: #ffffff;
	display: flex;
	align-items: center;
	margin-left: 0.3rem;
	color: #333333;
	font-size: 0.28rem;
	border-bottom: 1px solid #f1f1f1;
	justify-content: space-between;
}

.check {
	width: 0.36rem;
	height: 0.36rem;
	background-image: url("../assets/images/icon_checkbox_normal.png");
	background-size: contain;
	background-repeat: no-repeat;
	margin-right: 0.3rem;
}
.active .check {
	background-image: url("../assets/images/icon_checkbox_selected.png");
}
.submit {
	width: 7.5rem;
	height: 1.58rem;
	background: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
}
.submit p {
	width: 6.9rem;
	height: 1rem;
	background: linear-gradient(90deg, #68b3fd 0%, #5c85ff 100%);
	border-radius: 0.2rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.36rem;
	color: #ffffff;
	line-height: 0.5rem;
	letter-spacing: 1px;
}
.show-level-content {
	height: 4.32rem;
}
.show-level-li {
	width: 6.9rem;
	height: 1.07rem;
	border-bottom: 1px solid #f1f1f1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 0 0.3rem;

	font-size: 0.28rem;
	color: #333333;
}
.pages {
	width: 1.77rem;
	height: 0.6rem;
	background: #002695;
	border-radius: 0.37rem;
	opacity: 0.8;
	position: absolute;
	right: 0.3rem;
	display: flex;
	align-items: center;
}
.pages i {
	width: 50%;
	height: 100%;
	background-size: 0.4rem 0.4rem;
	background-repeat: no-repeat;
	background-position: center center;
}
.pages .line {
	width: 0.01rem;
	height: 0.4rem;
	background: #4765b3;
}
.pages i.up {
	background-image: url("../assets/images/icon_page_up.png");
}
.pages i.down {
	background-image: url("../assets/images/icon_page_down.png");
}
.input-div {
	display: flex;
	align-items: center;
	margin-bottom: 0.3rem;
}
.input-div span {
	width: 1.42rem;
	font-size: 0.28rem;
	color: #333333;
}
.input-money {
	width: 4.88rem;
	height: 0.8rem;
	background: #ffffff;
	border-radius: 0.1rem;
	border: 0.01rem solid #dddddd;
	padding: 0 0.3rem;
	font-size: 0.28rem;
	color: #333;
}

.input-money:focus {
	border: 1px solid #5e8dfe;
}

.input-money::placeholder {
	color: #888;
}
</style>
